<template>
  <div>
    <div
      :class="`notifylist-drawer ${collapsed ? 'notifylist-collapsed' : ''}`"
      :style="{zIndex: zIndex}"
    >
      <div style="height:100%">
        <div class="notifylist-action" style="padding-right: 20px">
          <span style="margin-right: 20px;">
            免打扰:
            <el-switch v-model="notNotify" @change="setNotNotify"></el-switch>
          </span>
          <span class="radish-link" @click="readAll">全部标为已读</span>
        </div>
        <el-tabs v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane v-for="t in types" :key="t" :label="t" :name="t"></el-tab-pane>
        </el-tabs>
        <div v-if="activeTab === '到岗'" class="notifylist-content">
          <el-card v-for="noti in list" :key="noti._id" class="notifylist-item">
            <div class="notifylist-item-title">{{ noti.人选 }} - 到岗提示</div>
            <div class="notifylist-item-subtitle flex-row justify-between">
              <div>{{ dateFormat(new Date(noti.remindTime || noti.createdAt), 'yyyy-mm-dd HH:MM') }}</div>
            </div>
            <div class="notifylist-item-main">
              <div>项目：{{ noti.项目 }}</div>
              <div>到岗日期：{{ noti.到岗 }}</div>
              <div>
                <span style="margin-right:15px;">开票金额：{{ noti.开票金额 }}</span>
                <span>开票状态：{{ noti.开票状态 }}</span>
              </div>
            </div>
            <div class="notifylist-action">
              <span class="radish-link" @click="gotoRadish(noti)">
                查看人选
              </span>
              <span class="radish-link" @click="gotoFinance(noti)">
                查看财务
              </span>
              <span class="radish-link" @click="delItem(noti._id)">删除</span>
            </div>
          </el-card>
        </div>
        <div v-else class="notifylist-content">
          <el-card
            v-for="item in list" :key="item._id" class="notifylist-item"
            :class="{'notify-item-red': (item.action == '推荐报告完成' && !item.completed) }"
          >
            <el-badge v-if="!item.read" is-dot class="notifier-item-icon"></el-badge>
            <div class="notifylist-item-title">{{ item.title }}</div>
            <div class="notifylist-item-subtitle flex-row justify-between">
              <div>{{ item.action }}</div>
              <div>{{ dateFormat(new Date(item.remindTime || item.createdAt), 'yyyy-mm-dd HH:MM') }}</div>
            </div>
            <div class="notifylist-item-main">
              <pre v-if="item.type == '系统'">{{ formatContent(item.content) }}</pre>
              <span v-else>{{ formatContent(item.content) }}</span>
            </div>
            <div class="notifylist-action">
              <span
                v-if="
                  (item.type == '项目' && item.pid) ||
                    (item.type == '人选' && item.rid) ||
                    (item.type == '行政' && item.sheetId)
                "
                class="radish-link"
                @click="clickItem(item)"
              >
                查看{{ linkMap[item.type] }}
              </span>
              <span
                v-else-if="item.action == '推荐报告完成' && item.rid && item.pid"
                class="radish-link"
                :style="`color:${item.completed?'#409eff':'#f56c6c'}`"
                @click="clickItem(item)"
              >
                {{item.completed?'查看':'完善'}}推荐报告
              </span>
              <span
                v-if="(item.type == '项目' || item.action == '推荐报告制作中' || item.action == '投递简历') && item.rid"
                class="radish-link"
                @click="gotoRadish(item)"
              >
                查看人选
              </span>
              <span
                v-if="item.type == '情报' && item.bid"
                class="radish-link"
                @click="showBull(item.bid)"
              >
                查看详情
              </span>
              <span
                v-if="item.type == '行政' && item.action==='业绩分成' && item.rid && item.pid"
                class="radish-link"
                @click="toYeji(item.rid,item.pid)"
              >
                前往确认
              </span>
              <span v-if="!item.read" class="radish-link" @click="readItem(item._id)">标为已读</span>
              <span class="radish-link" @click="delItem(item._id)">删除</span>
            </div>
          </el-card>
        </div>
        <el-pagination
          class="notifylist-pagination"
          :total="total"
          :page-size="limit"
          layout="prev, pager, next"
          @current-change="onPageChange"
        />
      </div>
      <div class="notifylist-toggle-btn notifylist-close-btn ft-danger pointer" @click="toggle">
        <i class="el-icon-circle-close" />
      </div>
      <bulletinDetail ref="bulletinDetail"></bulletinDetail>
    </div>
  </div>
</template>

<script>
const dateFormat = require('dateformat')
import bulletinDetail from './bulletin/bulletinDetail.vue'
export default {
  components: {bulletinDetail},
  data() {
    return {
      interval: 1000 * 60 * 1,
      collapsed: true,
      list: [],
      limit: 20,
      skip: 0,
      total: 0,
      unReadCount: 0,
      linkMap: {
        项目: '项目',
        人选: '人选',
        行政: 'searchlist',
        推荐报告: '推荐报告',
        情报: '情报',
      },
      // types: ['全部未读', '项目', '人选', '推荐报告', '系统', '情报', '到岗', '行政'],
      types: ['全部未读', '项目', '人选', '推荐报告', '系统', '情报', '行政'],
      activeTab: app.user.角色 && app.user.角色.includes('行政') ? '行政' : '全部未读',
      lastRemindedIds: [],
      zIndex: 1001,
      rploading: false,
      notNotify: false,
    }
  },
  computed: {
    dateFormat() {
      return dateFormat
    },
    root() {
      return window.app.root
    },
  },
  beforeDestroy() {
    this.load && window.clearInterval(this.load)
  },
  mounted() {
    this.notNotify = app.user.notNotify
    this.getUnremind()
    this.getUnreadNum()
    this.load = setInterval(() => {
      this.getUnremind()
      this.getUnreadNum()
    }, this.interval)
  },
  methods: {
    toYeji(rid,pid){
     window.open(`${window.frontend}/#/FinancePercent?rid=${rid}&pid=${pid}`, '_blank')
    },
    async toggle() {
      if (this.collapsed) {
        await this.loadData()
        this.zIndex = app.root.zIndex++
      }
      this.collapsed = !this.collapsed
    },
    async getUnremind() {
      try {
        const res = await app.service('notify').getUnremind()
        if (res.status === 'success') {
          if (!this.notNotify) {
            this.pushNotification(res.data)
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getUnreadNum() {
      try {
        const res = await app.service('notify').getUnreadNum()
        if (res.status === 'success') {
          this.root.msgCount = res.data
          this.unReadCount = res.data
        }
      } catch (error) {
        console.error(error)
      }
    },

    async loadData() {
      const { skip, limit } = this
      try {
        const query = {}
        if (this.activeTab === '到岗') {
          const param = { query, skip, limit }
          const res = await app.service('notify').listToworkNotify(param)
          if (res.status === 'success') {
            this.list = res.data.data.map(dt => {
              const dao = new Date(dt.到岗日期).getTime()
              const diff = parseInt((Date.now() - dao)/2592000000)
              dt.到岗 = dateFormat(dao, 'yyyy-mm-dd')
              if (diff) dt.到岗 += `(已到岗${diff}个月)`
              return dt
            })
            this.total = res.data.total
          }
        } else {
          if (this.activeTab == '全部未读') {
            query.read = {$in: [null, false]}
          } else {
            query.type = this.activeTab
          }
          const param = { query, skip, limit }
          if (this.activeTab == '推荐报告') {
            param.order = { action: -1, read: 1, remindTime: -1 }
          }
          const res = await app.service('notify').listNotify(param)
          if (res.status === 'success') {
            this.list = res.data.data
            this.total = res.data.total
            this.getUnreadNum()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    onPageChange(page) {
      this.skip = (page - 1) * this.limit
      this.loadData()
    },
    formatContent(content) {
      if (!content) return ''
      if (typeof content === 'string') return content
      // let tmp= JSON.stringify(content).replace(/([\{\}\"])/g, '').replace("\n","")
      // return tmp
      let tmp = ''
      for (const key of Object.keys(content)) {
        tmp += `${key}：${content[key]}；`
      }
      if (tmp.endsWith('；')) {
        tmp = tmp.substring(0, tmp.length - 1)
      }

      return tmp
    },
    async pushNotification(items) {
      if (!items || items.length === 0) return
      console.log('pushNotification -> items', items)
      const remindedIds = []
      for (let index = 0; index < items.length; index += 1) {
        const item = items[index]
        if (!this.lastRemindedIds.includes(item._id)) {
          remindedIds.push(item._id)
          await new Promise((resolve, reject) => {
            const formatedContent = this.formatContent(item.content)
            if (item.action == '系统公告' || item.action == '公司公告') {
              this.$alert(`<pre>${formatedContent}</pre>`, item.title, {
                confirmButtonText: '知道了',
                showClose: false,
                dangerouslyUseHTMLString: true,
                customClass: 'notify-message',
                callback: action => {
                  app.service('notify').modifyNotify({ query: { _id: item._id }, data: { read: true } })
                },
              })
            } else {
              this.$notify({
                title: item.title,
                type: 'success',
                duration: 10000,
                dangerouslyUseHTMLString: true,
                message:
                  (item.type == '项目' && item.pid) || (item.type == '人选' && item.rid) || (item.action == '推荐报告完成' && item.rid && item.pid) || item.type == '情报' && item.bid
                    ? `${formatedContent}<br><span class="radish-link">点击查看${this.linkMap[item.type]}</span>`
                    : formatedContent,
                onClick: () => {
                  this.clickItem(item)
                },
              })
            }
            app.service('notify').modifyNotify({ query: { _id: item._id }, data: { reminded: true } })
            this.$nextTick(() => {
              resolve()
            })
          }).catch(error => {
            console.error(error)
          })
        }
      }
      this.lastRemindedIds = remindedIds
    },
    async clickItem(item) {
      try {
        if (item.type == '项目' && item.pid) {
          window.open(`${window.frontend}/#/project20/${item.pid}`, '_blank')
        } else if (item.type == '人选' && item.rid) {
          window.open(`${window.frontend}/#/radish-detail-blank/${item.rid}`, '_blank')
        } else if (item.type == '行政' && item.sheetId) {
          const res = await app.service('radish').excelCheck({ sheetId: item.sheetId })
          if (res.status === 'success') {
            app.root.$refs.ExcelCorrection.show({
              records: res.data,
              sheetId: item.sheetId,
              notifyInfo: { from: item.from, originalname: item.originalname },
            })
          } else {
            this.$message.warning(res.msg)
          }
          this.toggle()
        } else if (item.type == '情报' && item.bid) {
          this.showBull(item.bid)
        } else if (item.type == '行政' && item.action==='业绩分成' && item.rid && item.pid) {
          this.toYeji(item.rid,item.pid)
        }else if (item.action == '推荐报告完成') {
          try {
            if (item.recommendReportId) {
              const rp = await app.service('recommendReport').get(item.recommendReportId)
              if (!item.completed) {
                if (rp.completed) {
                  item.completed = true
                }
              }
              if (item.completed) {
                // this.$message('该推荐报告已经由顾问修改完成，请到人选完整推荐报告中下载')
                window.open(`${window.frontend}/#/radish-detail-blank/${item.rid}?ltab=附件&subltab=full`, '_blank')
                return false
              }
              if (this.rploading) {
                return this.$message('正在加载中请耐心等待')
              } else {
                this.$message('加载中...')
              }
              this.rploading = true

              const ref = window.app.root.$refs.cvPreview
              await ref.getFile(item, { showHighlight: true, rid: item.rid, pid: item.pid, width: '43vw' })

              await app.root.$refs.ReportTemplateV2.init({
                rid: item.rid, pid: item.pid, md5: item.md5,
                templateId: (rp.spTemplate && rp.spTemplate._id) ? rp.spTemplate._id: '',
                recommendReportId: item.recommendReportId, loadLastWps: true
              })
              this.rploading = false
            } else {
              this.$message('没有对应的推荐报告')
            }
          } catch (e) {
            console.error(e)
          }
        }
        if (!item.read) await this.readItem(item._id)
      } catch (error) {
        console.error(error)
      }
    },
    gotoRadish(item) {
      window.open(`${window.frontend}/#/radish-detail-blank/${item.rid}`, '_blank')
    },
    gotoFinance() {
      window.open(`${window.frontend}/#/SimpleUserFinance`, '_blank')
    },
    async showBull(bid) {
      // bid = 'SJ05QcRBt'
      const res = await app.service('misc').listBulletinsSample({ query: { _id: bid }, limit: 1 })
      if (res.status === 'success') {
        const rows = res.data.data
        if (rows.length > 0) return this.$refs.bulletinDetail.show(rows[0])
      }
      this.$message('未找到情报')
    },
    async readItem(_id) {
      try {
        const res = await app.service('notify').modifyNotify({ query: { _id }, data: { read: true } })
        if (res.status === 'success') {
          this.list = this.list.map(l => {
            if (l._id === _id) l.read = true
            return l
          })
          this.root.msgCount--
          this.unReadCount--
        }
      } catch (error) {
        console.error(error)
      }
    },
    async delItem(_id) {
      try {
        let res = {}
        if (this.activeTab === '到岗') {
          res = await app.service('notify').modifyToworkNotify({ query: { _id }, isDeleted: true })
        } else {
          res = await app.service('notify').modifyNotify({ query: { _id }, data: { isDeleted: true } })
        }
        if (res.status === 'success') {
          this.$message.success('操作成功')
          this.loadData()
        }
      } catch (error) {
        console.error(error)
      }
    },
    async readAll() {
      try {
        const res = await app
          .service('notify')
          .modifyNotify({ query: { sendTo: app.user.account, read: false }, data: { read: true } })
        if (res.status === 'success') {
          this.loadData()
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleTabClick() {
      this.skip = 0
      this.loadData()
    },
    async setNotNotify() {
      await app.service('users').patch(app.user._id, {
        notNotify: this.notNotify,
      })
      app.user.notNotify = this.notNotify
    }
  },
}
</script>

<style>
.notifylist-drawer {
  position: fixed;
  top: 61px;
  right: 0;
  bottom: 0;
  width: 565px;
  padding: 15px;
  background-color: #fff;
  transition: all 0.2s ease-out;
  border-left: 1px solid #eee;
}
.notifylist-collapsed {
  transform: translate(0, 100%);
}
.notifylist-content {
  height: 100%;
  overflow: auto;
  padding-bottom: 95px;
}
.notifylist-pagination {
  position: relative;
  top: -90px;
  text-align: center;
  background-color: #fff;
}
.notifylist-item {
  position: relative;
  margin-bottom: 3px;
}
.notify-item-red {
  border: 1px solid #f56c6c;
}
.notifylist-item-title {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: normal;
  color: #444;
}
.notifylist-item-subtitle {
  color: #999;
}
.notifylist-item-main {
  color: #444;
}
.notifylist-close-btn {
  font-size: 16px;
  position: absolute;
  top: 5px;
  right: 10px;
}
.notifier-item-icon {
  position: absolute;
  left: 5px;
  top: 25px;
}
.notifylist-action {
  text-align: right;
}
.notifylist-action .radish-link {
  margin-left: 5px;
}
.notifylist-drawer .el-tabs__header {
  margin: 0 0 5px;
}
.notify-message {
  width: 50%;
}
.notify-message pre {
  white-space: pre-wrap;
  max-height: 80vh;
  overflow: auto;
}
</style>
